// inv/src/components/ui/menuContext.jsx
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { cn } from '../../lib/utils';
export function MenuContext({ trigger, items = [], open, onOpenChange }) {
  return (
    <DropdownMenu.Root open={open} onOpenChange={onOpenChange}>
      <DropdownMenu.Trigger asChild>
        {trigger}
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className={cn(
            'z-50 min-w-[180px] rounded-md border bg-white p-1 shadow-md',
            'radix-side-top:animate-slide-up radix-side-bottom:animate-slide-down'
          )}
          side="bottom"
          sideOffset={4}
          align="end"
        >
          {items.map((item, idx) => {
            if (item.separator) {
              return <DropdownMenu.Separator key={idx} className="my-1 h-px bg-stone-200" />;
            }
            return (
              <DropdownMenu.Item
                key={idx}
                onSelect={(event) => {
                  if (item.keepOpen) {
                    event.preventDefault();
                  }
                  item.onClick?.(event);
                }}
                disabled={item.disabled}
                className={cn(
                  'group relative flex cursor-pointer select-none items-center rounded-md px-2 py-1.5 text-sm outline-none',
                  item.variant === 'destructive'
                    ? 'text-red-700 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50'
                    : 'text-stone-700 hover:bg-stone-100 disabled:cursor-not-allowed disabled:opacity-50'
                )}
              >
                {item.icon && (
                  <item.icon
                    className={cn(
                      'mr-2 h-4 w-4',
                      item.variant === 'destructive'
                        ? 'text-red-500 group-hover:text-red-700'
                        : 'text-stone-500 group-hover:text-stone-700'
                    )}
                  />
                )}
                <span className="flex-grow truncate">{item.label}</span>
              </DropdownMenu.Item>
            );
          })}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
